import { Controller } from "@hotwired/stimulus"

import Swipe from 'swipejs';

// Connects to data-controller="swiper"
export default class extends Controller {
  static targets = [ "prev", "next" ]
  static values = { page: Number }

  connect() {
    var startSlide = 0;

    if(this.hasPageValue) {
      startSlide = this.pageValue;
    }

    window.galSwipe = this.swipe  = new Swipe(document.getElementById('slider'), {
      startSlide: startSlide,
      speed: 600,
      auto: false,
      draggable: true,
      continuous: false,
      disableScroll: false,
      stopPropagation: false,
      ignore: ".scroller",
      callback: function(index, elem, dir) {},
      transitionEnd: function(index, elem) {}
    });


    this.prevTarget.onclick = this.swipe.prev;
    this.nextTarget.onclick = this.swipe.next;

    // this.swiper = new Swiper('.swiper-container', {
    //   // Swiper configuration options
    //   // pagination: {
    //   //   el: ".swiper-pagination",
    //   // },
    //   lazy: true,
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    // });

  }
}
